export default __webpack_public_path__ + "068686feab1c62869d35ed1778d694ed.svg";